import Vue from 'vue';
import App from './App.vue';
import router from "./router";
import vuetify from './plugins/vuetify';
import store from './store';
import axios from 'axios';


axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;
Vue.config.devtools = process.env.VUE_APP_DEV_TOOLS === "TRUE";
Vue.config.productionTip = false;

import VueMask from 'v-mask'
Vue.use(VueMask);

new Vue({
  router,
  vuetify,
  store,
  render: h => h(App)
}).$mount('#app');
